import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import ServicesPage from "../pages/services/page";
import SionPage from "../pages/localities/SionPage";
import SierrePage from "../pages/localities/SierrePage";
import MartignyPage from "../pages/localities/MartignyPage";
import GronePage from "../pages/localities/GronePage";
import CransMontanaPage from "../pages/localities/CransMontanaPage";
import VerbierPage from "../pages/localities/VerbierPage";
import NendazPage from "../pages/localities/NendazPage";
import VercorinPage from "../pages/localities/VercorinPage";
import NaxPage from "../pages/localities/NaxPage";
import PrivacyPage from "../pages/privacy/page";
import SitemapPage from "../pages/sitemap/page";
import ContactPage from "../pages/contact/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/services",
    element: <ServicesPage />,
  },
  {
    path: "/sion",
    element: <SionPage />,
  },
  {
    path: "/sierre",
    element: <SierrePage />,
  },
  {
    path: "/martigny",
    element: <MartignyPage />,
  },
  {
    path: "/grone",
    element: <GronePage />,
  },
  {
    path: "/crans-montana",
    element: <CransMontanaPage />,
  },
  {
    path: "/verbier",
    element: <VerbierPage />,
  },
  {
    path: "/nendaz",
    element: <NendazPage />,
  },
  {
    path: "/vercorin",
    element: <VercorinPage />,
  },
  {
    path: "/nax",
    element: <NaxPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/sitemap",
    element: <SitemapPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
